import React, { forwardRef } from "react";
import { MessageSquare } from "lucide-react";
import { useApp } from "@/context/AppContext";

function fmt(iso, lang) {
  try {
    return new Date(iso).toLocaleTimeString(lang === "it" ? "it-IT" : "en-US", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

function Bubble({ msg, mine, lang }) {
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`chat-msg-${msg.id}`}>
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2 text-sm ${
          mine
            ? "bg-[#2E2A22] text-[#F5F0E6] rounded-br-sm"
            : "bg-white border border-[#D8CFBB] text-[#1A1610] rounded-bl-sm"
        }`}
      >
        {!mine && (
          <p className="text-[10px] text-[#8a7658] uppercase tracking-widest mb-0.5">{msg.sender_name}</p>
        )}
        <p className="whitespace-pre-wrap break-words">{msg.text}</p>
        <p className={`text-[9px] mt-0.5 ${mine ? "text-[#C5A880]/70" : "text-[#B8A98F]"}`}>
          {fmt(msg.created_at, lang)}
        </p>
      </div>
    </div>
  );
}

const ChatMessages = forwardRef(function ChatMessages({ messages, myUserId }, ref) {
  const { lang } = useApp();
  return (
    <div
      ref={ref}
      className="h-[400px] overflow-y-auto px-5 py-4 space-y-3 bg-[#FBF8F1]"
      data-testid="chat-messages"
    >
      {!messages.length && (
        <div className="h-full flex flex-col items-center justify-center text-center text-[#B8A98F]">
          <MessageSquare className="w-10 h-10 mb-3 opacity-50" />
          <p className="text-xs">
            {lang === "it"
              ? "Nessun messaggio ancora. Rompi il ghiaccio!"
              : "No messages yet. Break the ice!"}
          </p>
        </div>
      )}
      {messages.map((m) => (
        <Bubble key={m.id} msg={m} mine={m.sender_id === myUserId} lang={lang} />
      ))}
    </div>
  );
});

export default ChatMessages;
